function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInProgress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "in_progress") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3697",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.746 204a.736.736 0 0 0 .536-.214.714.714 0 0 0 .219-.531.736.736 0 0 0-.214-.536.714.714 0 0 0-.531-.219.736.736 0 0 0-.536.214.714.714 0 0 0-.219.531.736.736 0 0 0 .214.536.714.714 0 0 0 .531.219zm2.25 0a.736.736 0 0 0 .536-.214.714.714 0 0 0 .219-.531.736.736 0 0 0-.214-.536.714.714 0 0 0-.537-.219.736.736 0 0 0-.536.214.714.714 0 0 0-.219.531.736.736 0 0 0 .214.536.714.714 0 0 0 .541.219zm2.25 0a.736.736 0 0 0 .536-.214.714.714 0 0 0 .219-.531.736.736 0 0 0-.214-.536.714.714 0 0 0-.531-.219.736.736 0 0 0-.536.214.714.714 0 0 0-.219.531.736.736 0 0 0 .214.536.714.714 0 0 0 .531.219zm-3.1-2.4 4.542-4.542-1.063-1.058-3.479 3.479-1.771-1.771-1.062 1.063zm.86 6.4a7.811 7.811 0 0 1-3.11-.625 8.036 8.036 0 0 1-4.271-4.27 8.049 8.049 0 0 1 0-6.22 8.063 8.063 0 0 1 4.27-4.26 8.049 8.049 0 0 1 6.22 0 8.077 8.077 0 0 1 4.26 4.265 8.035 8.035 0 0 1 0 6.214 8.049 8.049 0 0 1-4.265 4.271 7.77 7.77 0 0 1-3.104.625z",
    transform: "translate(-92 -188)",
    style: {
      fill: "#21a2ee"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInProgress);
export default __webpack_public_path__ + "static/media/in_progress.853f68c5c15eae5f6f16e37e94515202.svg";
export { ForwardRef as ReactComponent };